<template>
  <div class="file-uploader" :class="{ 'has-file': file }">
    <label class="upload-wrapper">
      <slot name="icon" />
      <span>{{ label }}</span>
      <input type="file" ref="file" @change="filesChanged" accept="*" />
    </label>
    <div class="file-name" v-if="file && file.name">
      <span><strong>File:</strong> {{ file.name }}</span>
      <a @click="reset">Clear</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "FileUpload",
    props: {
      icon: String,
      label: {
        type: String,
        default: "Add a file to upload"
      },
      selectedFile: File
    },
    data: () => ({
      file: null
    }),
    mounted() {
      if (this.selectedFile) {
        this.file = this.selectedFile;
      }
    },
    methods: {
      reset() {
        this.file = null;
        this.$refs.file.value = null;
        this.$emit("change", this.file);
      },
      filesChanged() {
        const files = this.$refs.file.files;
        if (!files.length) return;
        this.file = files[0];
        this.$emit("change", this.file);
      }
    },
    computed: {
      filename() {
        return this.file ? this.file.name : null;
      }
    }
  };
</script>

<style scoped lang="scss">
  .file-uploader {
    .upload-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 1px dashed $color-border;
      background: #f9f9f9;
      border-radius: 10px;
      padding: 30px;
      position: relative;
      cursor: pointer;
      color: $color-primary;

      &:hover {
        background: rgba($color-primary, 0.03);
        border-color: $color-primary;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.07);

        svg {
          fill: $color-primary;
        }
      }

      svg {
        fill: #ccc;
        margin-bottom: 10px;
      }

      input {
        opacity: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        cursor: pointer;
      }
    }

    .file-name {
      display: flex;
      font-size: 14px;
      border: 1px dashed $color-border;
      background: #f9f9f9;
      border-radius: 0 0 10px 10px;
      padding: 10px $gutter;

      span {
        flex-grow: 1;
      }

      a:hover {
        cursor: pointer;
      }
    }

    &.has-file {
      .upload-wrapper {
        border-radius: 10px 10px 0 0;
      }
    }
  }
</style>
